<!-- TEMPLATE -->
<template>
  <span class="required-field-text">
    <span class="rqf-star">*</span>
    <span><slot></slot></span>
  </span>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({})
export default class deanRequiredFieldText extends Vue {}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
/* IMPORT */
@import '../scss/vars';

.required-field-text {
  width: 100%;
  @include display-flex;
  justify-content: flex-end;
  padding: 10px 20px 10px 20px;
  color: var(--color-dark-shade-4, $color-dark-shade-4);
  .rqf-star {
    padding-right: 2px;
    color: var(--color-primary, $color-primary);
  }
}
</style>
